import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { thunk as thunkMiddleware }     from 'redux-thunk';
import authReducer                     from './reducers/authReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  // …other reducers…
});

// Use the browser extension’s compose if it’s installed, otherwise Redux’s
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunkMiddleware)
  )
);

export default store;
